<!-- =========================================================================================
    File Name: Attività.vue
    Description: Calendario delle attività
    ----------------------------------------------------------------------------------------
    Item Name:
      Author:
    Author URL:
========================================================================================== -->
<template>
  <vx-card>

    <FullCalendar :key="calkey" :options="calendarOptions" />
    <vs-popup v-if="selected" :key="Math.random()" class="holamundo text-center" title="Informazioni Attività" :active.sync="popupInfo">
      <vs-row class="m-3">
        <vs-col vs-offset="2" vs-type="flex" vs-justify="center" vs-align="center" vs-w="8">
          <p class="mb-3">
            {{['Tipo: ',selected.tipo].join("")}}
          </p>
        </vs-col>
        <vs-col vs-offset="2" vs-type="flex" vs-justify="center" vs-align="center" vs-w="8">
          <p class="mb-3">
            {{['Data scadenza: ',this.$tariffe.formatDateNew(selected.data_scadenza)].join("")}}
          </p>
        </vs-col>
        <vs-col v-if="selected.data_completamento" vs-offset="2" vs-type="flex" vs-justify="center" vs-align="center" vs-w="8">
          <p class="mb-3 c-primary">
            {{['Data completamento: ',this.$tariffe.formatDateNew(selected.data_completamento)].join("")}}
          </p>
        </vs-col>
        <vs-col v-if="selected.azienda" vs-offset="2" vs-type="flex" vs-justify="center" vs-align="center" vs-w="8">
          <p class="mb-3">
            {{['Azienda: ',selected.azienda.ragione_sociale].join("")}}
          </p>
        </vs-col>
        <vs-col v-if="selected.lead" vs-offset="2" vs-type="flex" vs-justify="center" vs-align="center" vs-w="8">
          <p class="mb-3">
            {{['Lead: ',selected.lead.titolo].join("")}}
          </p>
        </vs-col>
        <vs-col v-if="selected.contatto" vs-offset="2" vs-type="flex" vs-justify="center" vs-align="center" vs-w="8">
          <p class="mb-3">
            {{['Contatto: ',selected.contatto.cognome,selected.contatto.nome].join(" ")}}
          </p>
        </vs-col>
        <vs-col v-if="selected.orario_hh" vs-offset="2" vs-type="flex" vs-justify="center" vs-align="center" vs-w="8">
          <label class="mx-2 mb-3">Orario fissato: {{selected.orario_hh}}</label>
        </vs-col>
        <vs-col v-if="selected.orario_fine_hh" vs-offset="2" vs-type="flex" vs-justify="center" vs-align="center" vs-w="8">
          <label class="mx-2 mb-3">Orario termine: {{selected.orario_fine_hh}}</label>
        </vs-col>
        <vs-col v-if="selected.descrizione" vs-offset="2" vs-type="flex" vs-justify="center" vs-align="center" vs-w="8">
          <label class="mx-2 mb-3">Note: {{selected.descrizione}}</label>
        </vs-col>
      </vs-row>
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
        <vs-button @click="showAttivita(selected, $event)" icon-pack="feather" icon="icon-edit" type="line" color="warning"> Modifica </vs-button>
      </vs-col>
    </vs-popup>

    <vs-sidebar click-not-close position-right parent="body" color="primary" class="sidebarx sidebarpage sidebar-utenti" spacer v-model="isSidebarActive">
      <sidebar-form-attivita-lead :selected_date="sel_date" @close-me="sidebarClose" @attivita-lead-salvato="handleSave" @elimina-attivita-lead="handleEliminaAttivitaLead($event)" :altre_attivita="[]" :id_lead="selected && selected.id_lead ? _.cloneDeep(selected.id_lead) : null" :key="formkey" :selected="selected"></sidebar-form-attivita-lead>
    </vs-sidebar>

  </vx-card>
</template>

<script>

import axios from 'axios'
import SidebarFormAttivitaLead from '../boards/SidebarFormAttivitaLead.vue'
import Tooltip from 'tooltip-js'
import FullCalendar from '@fullcalendar/vue'
// components included into calendar options object
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import itLocale from '@fullcalendar/core/locales/it';

export default {
  name: 'app',
  data() {
    return {
    events: [],
    tipo_list: [],
    sel_date: null,
    haveSaved: false,
    sidebar_type: null,
    sidebar_active: false,
    formkey: null,
    calkey: null,
    selected: null,
    popupInfo: false,

    icon: {
      Telefonata: 'icon-phone-call',
      Mail: 'icon-mail',
      Appuntamento: 'icon-calendar'
    },

    calendarOptions: {
      locale: itLocale,
      timeZone: 'UTC+1',
      plugins: [ dayGridPlugin, timeGridPlugin, interactionPlugin ],
      customButtons: {
        new: {
          text: 'Nuova',
          click: this.addAttivita,
          // icon: 'icon-plus',
        },
      },
      headerToolbar: {
        left: 'prev,next today',
        center: 'title',
        right: 'dayGridMonth,timeGridWeek,timeGridDay new',
      },
      initialView: 'dayGridMonth',
      firstDay: 1,
      nowIndicator: true,

      dateClick: this.addAttivita,
      eventClick: this.showMainInfo,
      // eventDidMount: function(attivita) {
      //   var tooltip = new Tooltip(attivita, {
      //      title: attivita.el.text,
      //      placement: 'top',
      //      trigger: 'hover',
      //      container: 'body'
      //    });
      // },
      events: [],
      eventTimeFormat: { // like '14:30:00'
        hour: '2-digit',
        minute: '2-digit',
        meridiem: false
      },
      nextDayThreshold: '07:00:00',
     }
   }
  },
  components: {
    SidebarFormAttivitaLead,
    FullCalendar,
  },
  mounted()
  {
    this.getTipoAtt()
    this.getAttivitaLead()
  },
  computed: {
    isSidebarActive: {
      get() {
        return this.sidebar_active
      },
      set(val) {
        if(!val && this.haveSaved) {
          this.haveSaved = false
        }
        else {
          this.sidebar_active = val
        }
      }
    }
  },
  methods: {
    handleSave() {
      this.sidebar_active = !this.sidebar_active
      this.haveSaved = true
      this.formkey = Math.random()
      this.calkey = Math.random()
      this.selected = null
      this.selected_stato = null
      this.selected_lead = null
      this.selected_attivita = null
      this.getAttivitaLead()
      this.getTipoAtt()
    },
    showMainInfo(attivita,ev) {
      if (ev) {
        ev.stopPropagation()
      }
      this.selected = this.events.find(e => e.id == attivita.event._def.publicId)
      this.popupInfo = true
    },
    showAttivita(attivita,ev) {
      this.popupInfo = false
      this.formkey = Math.random()
      if (ev) {
        ev.stopPropagation()
      }

      // this.selected = this.events.find(e => e.id == attivita.event._def.publicId)
      this.sidebar_type = 'form-attivita-lead'
      this.haveSaved = false
      this.isSidebarActive = !this.sidebar_active

      if ((attivita && attivita.event && attivita.event._def.extendedProps.data_completamento) || this.selected.data_completamento) {
        this.selected['readonly'] = true
      }
      //   this.selected = this.events.find(e => e.id == attivita.event._def.publicId)
      //   this.sidebar_type = 'form-attivita-lead'
      //   this.haveSaved = false
      //   this.isSidebarActive = !this.sidebar_active
      // } else {
      //   this.$vs.notify({
      //     color: 'warning',
      //     time: 4000,
      //     title: 'Attività già completata',
      //     text: ''
      //   })
      // }
    },
    addAttivita(arg) {
      this.sel_date = arg.date
      this.sidebar_type = 'form-attivita-lead'
      this.selected = null
      this.formkey = Math.random()
      this.sidebar_active = !this.sidebar_active
    },
    handleEliminaAttivitaLead(id) {
      this.isSidebarActive = !this.sidebar_active
      axios.post(process.env.VUE_APP_BACKEND_API+'/board/attivita_lead/elimina', { id: id },{
          headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
          withCredentials: true,
        })
        .then(() => {
          this.haveSaved = true
          this.getAttivitaLead()
        } )
        .catch(e => console.log(e))
    },
    getAttivitaLead() {
      this.activeLoading = true
      this.$vs.loading({
        type:'radius',
      })
      axios.post(process.env.VUE_APP_BACKEND_API+'/board/get_attivita_lead', {
        option: "Tutti",
        keyword: "",
        type: 'tipo',
      }, {
        headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
        withCredentials: true
      }).then(response => {
        this.events = []
        let num = 0
        response.data.forEach(e => {
          e['className'] = 'my_event calendar_event_'+num++
          e['title'] = e['tipo']
          e['start'] = e.data_scadenza
          e['end'] = e.data_completamento
          e['allDay'] = true // Never display time with the event
          if (e['orario_hh'] && e['orario_mm']) {
            // 2020-05-19T00:00:00.000Z
            e['start'] = e['data_scadenza'].slice(0,11)+e['orario_hh']+':'+e['orario_mm']+':00.000Z'
            e['allDay'] = false
          }
          if (e['orario_fine_hh'] && e['orario_fine_mm']) {
            e['end'] = e['data_completamento'].slice(0,11)+e['orario_fine_hh']+':'+e['orario_fine_mm']+':00.000Z'
            e['allDay'] = false
          }
          if (e['data_completamento']) e['className'] += ' completed'
          this.events.push(e)

        })
        this.calendarOptions['events'] = this.events

        this.$vs.loading.close()
      }).catch(e => this.$vs.loading.close())
    },
    sidebarClose() {
      this.selected = null
      this.sel_date = null
      this.sidebar_active = false
    },
    getTipoAtt() {
      axios.get(process.env.VUE_APP_BACKEND_API+'/board/tipi_attivita',{
        headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
        withCredentials: true
      }).then(e => {
        if (e.data.filter(e => e.tipo === 'Altro').length == 0) {
          e.data.push({tipo: 'Altro'})
        }
        if (e.data.filter(e => e.tipo === 'Appuntamento').length == 0) {
          e.data.push({tipo: 'Appuntamento'})
        }
        if (e.data.filter(e => e.tipo === 'Telefonata').length == 0) {
          e.data.push({tipo: 'Telefonata'})
        }
        if (e.data.filter(e => e.tipo === 'Mail').length == 0) {
          e.data.push({tipo: 'Mail'})
        }
        this.tipo_list = e.data.map(e => {
          e['label'] = `${e['tipo']}`
          return e
        })
        this.tipo_list.sort( (a,b) => (a.tipo > b.tipo) ? 1 : ((b.tipo > a.tipo) ? -1 : 0) )
      }).catch(e => console.log(e))
    },
    tooltipAttivita(attivita) {
      var tooltip = new Tooltip(attivita, {
         title: 'ìTESSSST',
         placement: 'top',
         trigger: 'hover',
         container: 'body'
       });
    }
  }
}
</script>

<style>
.appuntamento {
  background-color: #7367f0 !important;
}

.telefonata {
  background-color: #0088cc !important;
}

.mail {
  background-color: #3dcc00 !important;
}

.altro {
  background-color: #f9c9f9 !important;
}
</style>
